<mat-card class="mat-card-container no-shadow" (click)="selectClient(client)">
    <div class="row">
        <!-- client name and ID/passport -->
        <div class="col-3">
            <div class="name-container">
                <div class="logo-container">
                    <img
                        *ngIf="
                            client.profilePictureUri;
                            else noClientProfilePicture
                        "
                        [src]="client.profilePictureUri"
                        class="logo-image round-icon" />

                    <ng-template #noClientProfilePicture>
                        <mat-icon class="default-icon">person</mat-icon>
                    </ng-template>
                </div>
                <div class="name-section">
                    <h2 class="name-header-text" *ngIf="client.fullName">
                        {{ client.fullName.title?.name }}
                        {{
                            client.fullName.initials
                                ? client.fullName.initials
                                : client.fullName.name
                        }}
                        {{ client.fullName.surname }}
                    </h2>

                    <p
                        *ngIf="client.rsaIdNo; else passportNo"
                        class="name-subheading-text">
                        {{ client.rsaIdNo }}
                    </p>

                    <ng-template #passportNo>
                        <p
                            class="name-subheading-text"
                            *ngIf="client.passportNo">
                            {{ client.passportNo }} (Passport)
                        </p>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="col-3">
            <div class="name-container">
                <div class="logo-container">
                    <img
                        *ngIf="
                            client.policy.product.logoUri;
                            else noProductLogo
                        "
                        [src]="client.policy.product.logoUri"
                        class="logo-image" />

                    <ng-template #noProductLogo>
                        <mat-icon class="default-icon"
                            >shopping_basket</mat-icon
                        >
                    </ng-template>
                </div>

                <div class="name-section">
                    <h2 class="name-header-text">
                        {{ client.policy.product.name }}
                    </h2>

                    <p
                        *ngIf="client.policy.policyNo"
                        class="name-subheading-text">
                        {{ client.policy.policyNo }}
                    </p>
                </div>
            </div>
        </div>

        <!-- client type and language -->
        <div class="col-2">
            <div class="name-container">
                <div class="name-section">
                    <h2 class="name-header-text">
                        {{ client.clientType.name }} Client
                        <span
                            *ngIf="
                                client.clientType.clientTypeId ==
                                clientType.Business
                            "
                            >({{ client.businessName }})</span
                        >
                    </h2>

                    <p class="name-subheading-text">
                        {{ client.language.name }}
                    </p>
                </div>
            </div>
        </div>

        <!-- commencement date -->
        <div class="col-2 center">
            <p class="small-detail-text">
                {{
                    client.policy.commencementDate
                        ? (client.policy.commencementDate
                          | date : 'dd MMM yyyy')
                        : '-'
                }}
            </p>
        </div>

        <!-- policy status -->
        <div class="col-2">
            <div *ngIf="client.policy.policyStatus">
                <p
                    class="active-state-text"
                    [ngStyle]="{
                        'background-color': client.policy.policyStatusColourHex
                    }">
                    {{ client.policy.policyStatus }}
                    {{
                        client.policy.policySubStatus
                            ? ' - ' + client.policy.policySubStatus
                            : ''
                    }}
                </p>
            </div>
        </div>
    </div>
</mat-card>
